<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';

    @Component({
        watch: {
            opened: 'onOpenedChanged',
            surveyId: 'onSurveyIdChanged'
        },
        props: {
            propOpened: { type: Boolean, required: true, default: false },
            propDefaultSurveyId: { type: Number, required: false },
            propDefaultProjectUserId: { type: Number, required: false },
            propSurveys: { type: Array, required: true },
            propProjectUsers: { type: Array, required: true }
        }
    })
    export default class ScoringVotesSourceSelectorDialog extends Vue {
        get opened(): boolean { return this.$props.propOpened; }
        get defaultSurveyId(): number | null { return this.$props.propDefaultSurveyId as number | null; }
        get defaultProjectUserId(): number | null { return this.$props.propDefaultProjectUserId as number | null; }
        get surveys(): { Id: number, Name: string }[] { return this.$props.propSurveys as { Id: number, Name: string }[]; }
        get projectUsers(): { Id: number, Name: string }[] { return this.$props.propProjectUsers as { Id: number, Name: string }[]; }

        surveyId: number | null = null;
        projectUserId: number | null = null;

        //@Watch('opened')
        onOpenedChanged(val: boolean, oldVal: boolean)
        {
            if (val === true)
            {
                this.surveyId = this.defaultSurveyId;
                this.projectUserId = this.defaultProjectUserId;
            }
        }

        //@Watch('surveyId')
        onSurveyIdChanged(val: number, oldVal: number | null)
        {
            if (val != null)
            {
                this.projectUserId = null;
                this.$emit('load-panelists', val);
            }
        }

        confirm()
        {
            this.$emit('confirm-selection', this.surveyId, this.projectUserId);
        } 

        close()
        {
            this.$emit('close-dialog');
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened === true">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Evaluation</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group">
                            <label>Panel:</label>
                            <select v-model="surveyId" class="form-control">
                                <option v-for="s in surveys" :value="s.Id">{{s.Name}}</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label>Respondent:</label>
                            <select v-model="projectUserId" class="form-control">
                                <option :value="null">Aggregated</option>
                                <option v-for="p in projectUsers" :value="p.Id">{{p.Name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Close</button>
                        <button type="button" @click="confirm" class="btn btn-success">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template> 